import form from './form';
import list from './list';

export default {
    namespaced: true,
    modules: {
        "form": form,
        "list": list,
    }
}